import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'
import { TrainingDocumentsToProcessRouter } from './documents-to-process/_router'
import { TrainingSkylegsImportRouter } from './import/_router'
import { TrainingSkylegsRecordsRouter } from './records/_router'

const Index = lazy(() => import('./Index'))

export const TrainingSkylegsArchiveRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--skylegs-archive']}>
    <Route index element={<Index />} />
    <Route path='documents-to-process/*' element={<TrainingDocumentsToProcessRouter />} />
    <Route path='records/*' element={<TrainingSkylegsRecordsRouter />} />
    <Route path='import/*' element={<TrainingSkylegsImportRouter />} />
  </SubRouter>
))
